import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as ChangePasswordGenericError } from "./types/ChangePassword/ChangePasswordError";
import { InvalidParameterError as ChangePasswordInvalidParameterError } from "./types/ChangePassword/ChangePasswordError";
import { InvalidSecretError as ChangePasswordInvalidSecretError } from "./types/ChangePassword/ChangePasswordError";
import { ExpiredSecretError as ChangePasswordExpiredSecretError } from "./types/ChangePassword/ChangePasswordError";
import { NotFoundError as ChangePasswordNotFoundError } from "./types/ChangePassword/ChangePasswordError";
import { InternalServerError as ChangePasswordInternalServerError } from "./types/ChangePassword/ChangePasswordError";
import { BadGatewayError as ChangePasswordBadGatewayError } from "./types/ChangePassword/ChangePasswordError";
import { GatewayTimeoutError as ChangePasswordGatewayTimeoutError } from "./types/ChangePassword/ChangePasswordError";
import { GenericError as CreateTokenGenericError } from "./types/CreateToken/CreateTokenError";
import { InvalidParameterError as CreateTokenInvalidParameterError } from "./types/CreateToken/CreateTokenError";
import { InvalidCredentialsError as CreateTokenInvalidCredentialsError } from "./types/CreateToken/CreateTokenError";
import { PasswordRevokedError as CreateTokenPasswordRevokedError } from "./types/CreateToken/CreateTokenError";
import { IdentityDisabledError as CreateTokenIdentityDisabledError } from "./types/CreateToken/CreateTokenError";
import { InvalidAuthenticationModeError as CreateTokenInvalidAuthenticationModeError } from "./types/CreateToken/CreateTokenError";
import { MfaRequiredError as CreateTokenMfaRequiredError } from "./types/CreateToken/CreateTokenError";
import { NotFoundError as CreateTokenNotFoundError } from "./types/CreateToken/CreateTokenError";
import { ConflictError as CreateTokenConflictError } from "./types/CreateToken/CreateTokenError";
import { InternalServerError as CreateTokenInternalServerError } from "./types/CreateToken/CreateTokenError";
import { BadGatewayError as CreateTokenBadGatewayError } from "./types/CreateToken/CreateTokenError";
import { GatewayTimeoutError as CreateTokenGatewayTimeoutError } from "./types/CreateToken/CreateTokenError";
import { GenericError as ForgotPasswordGenericError } from "./types/ForgotPassword/ForgotPasswordError";
import { InvalidParameterError as ForgotPasswordInvalidParameterError } from "./types/ForgotPassword/ForgotPasswordError";
import { InvalidIdentityUsernameError as ForgotPasswordInvalidIdentityUsernameError } from "./types/ForgotPassword/ForgotPasswordError";
import { NotFoundError as ForgotPasswordNotFoundError } from "./types/ForgotPassword/ForgotPasswordError";
import { InternalServerError as ForgotPasswordInternalServerError } from "./types/ForgotPassword/ForgotPasswordError";
import { BadGatewayError as ForgotPasswordBadGatewayError } from "./types/ForgotPassword/ForgotPasswordError";
import { GatewayTimeoutError as ForgotPasswordGatewayTimeoutError } from "./types/ForgotPassword/ForgotPasswordError";
import { GenericError as GetSigninConfigurationGenericError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { InvalidParameterError as GetSigninConfigurationInvalidParameterError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { NotFoundError as GetSigninConfigurationNotFoundError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { InternalServerError as GetSigninConfigurationInternalServerError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { BadGatewayError as GetSigninConfigurationBadGatewayError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { GatewayTimeoutError as GetSigninConfigurationGatewayTimeoutError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { GenericError as ResetPasswordGenericError } from "./types/ResetPassword/ResetPasswordError";
import { InvalidParameterError as ResetPasswordInvalidParameterError } from "./types/ResetPassword/ResetPasswordError";
import { InvalidSecretError as ResetPasswordInvalidSecretError } from "./types/ResetPassword/ResetPasswordError";
import { ExpiredSecretError as ResetPasswordExpiredSecretError } from "./types/ResetPassword/ResetPasswordError";
import { NotFoundError as ResetPasswordNotFoundError } from "./types/ResetPassword/ResetPasswordError";
import { InternalServerError as ResetPasswordInternalServerError } from "./types/ResetPassword/ResetPasswordError";
import { BadGatewayError as ResetPasswordBadGatewayError } from "./types/ResetPassword/ResetPasswordError";
import { GatewayTimeoutError as ResetPasswordGatewayTimeoutError } from "./types/ResetPassword/ResetPasswordError";
import { GenericError as SsoSigninGenericError } from "./types/SsoSignin/SsoSigninError";
import { InvalidParameterError as SsoSigninInvalidParameterError } from "./types/SsoSignin/SsoSigninError";
import { NotFoundError as SsoSigninNotFoundError } from "./types/SsoSignin/SsoSigninError";
import { ConflictError as SsoSigninConflictError } from "./types/SsoSignin/SsoSigninError";
import { InternalServerError as SsoSigninInternalServerError } from "./types/SsoSignin/SsoSigninError";
import { BadGatewayError as SsoSigninBadGatewayError } from "./types/SsoSignin/SsoSigninError";
import { GatewayTimeoutError as SsoSigninGatewayTimeoutError } from "./types/SsoSignin/SsoSigninError";
export const errors = {
    ChangePassword: {
        InvalidParameterError: ChangePasswordInvalidParameterError,
        InvalidSecretError: ChangePasswordInvalidSecretError,
        ExpiredSecretError: ChangePasswordExpiredSecretError,
        NotFoundError: ChangePasswordNotFoundError,
        InternalServerError: ChangePasswordInternalServerError,
        BadGatewayError: ChangePasswordBadGatewayError,
        GatewayTimeoutError: ChangePasswordGatewayTimeoutError,
        GenericError: ChangePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateToken: {
        InvalidParameterError: CreateTokenInvalidParameterError,
        InvalidCredentialsError: CreateTokenInvalidCredentialsError,
        PasswordRevokedError: CreateTokenPasswordRevokedError,
        IdentityDisabledError: CreateTokenIdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenInvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenMfaRequiredError,
        NotFoundError: CreateTokenNotFoundError,
        ConflictError: CreateTokenConflictError,
        InternalServerError: CreateTokenInternalServerError,
        BadGatewayError: CreateTokenBadGatewayError,
        GatewayTimeoutError: CreateTokenGatewayTimeoutError,
        GenericError: CreateTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ForgotPassword: {
        InvalidParameterError: ForgotPasswordInvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordInvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordNotFoundError,
        InternalServerError: ForgotPasswordInternalServerError,
        BadGatewayError: ForgotPasswordBadGatewayError,
        GatewayTimeoutError: ForgotPasswordGatewayTimeoutError,
        GenericError: ForgotPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSigninConfiguration: {
        InvalidParameterError: GetSigninConfigurationInvalidParameterError,
        NotFoundError: GetSigninConfigurationNotFoundError,
        InternalServerError: GetSigninConfigurationInternalServerError,
        BadGatewayError: GetSigninConfigurationBadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationGatewayTimeoutError,
        GenericError: GetSigninConfigurationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetPassword: {
        InvalidParameterError: ResetPasswordInvalidParameterError,
        InvalidSecretError: ResetPasswordInvalidSecretError,
        ExpiredSecretError: ResetPasswordExpiredSecretError,
        NotFoundError: ResetPasswordNotFoundError,
        InternalServerError: ResetPasswordInternalServerError,
        BadGatewayError: ResetPasswordBadGatewayError,
        GatewayTimeoutError: ResetPasswordGatewayTimeoutError,
        GenericError: ResetPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SsoSignin: {
        InvalidParameterError: SsoSigninInvalidParameterError,
        NotFoundError: SsoSigninNotFoundError,
        ConflictError: SsoSigninConflictError,
        InternalServerError: SsoSigninInternalServerError,
        BadGatewayError: SsoSigninBadGatewayError,
        GatewayTimeoutError: SsoSigninGatewayTimeoutError,
        GenericError: SsoSigninGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ChangePasswordError: {
        InvalidParameterError: ChangePasswordInvalidParameterError,
        InvalidSecretError: ChangePasswordInvalidSecretError,
        ExpiredSecretError: ChangePasswordExpiredSecretError,
        NotFoundError: ChangePasswordNotFoundError,
        InternalServerError: ChangePasswordInternalServerError,
        BadGatewayError: ChangePasswordBadGatewayError,
        GatewayTimeoutError: ChangePasswordGatewayTimeoutError,
        GenericError: ChangePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTokenError: {
        InvalidParameterError: CreateTokenInvalidParameterError,
        InvalidCredentialsError: CreateTokenInvalidCredentialsError,
        PasswordRevokedError: CreateTokenPasswordRevokedError,
        IdentityDisabledError: CreateTokenIdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenInvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenMfaRequiredError,
        NotFoundError: CreateTokenNotFoundError,
        ConflictError: CreateTokenConflictError,
        InternalServerError: CreateTokenInternalServerError,
        BadGatewayError: CreateTokenBadGatewayError,
        GatewayTimeoutError: CreateTokenGatewayTimeoutError,
        GenericError: CreateTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ForgotPasswordError: {
        InvalidParameterError: ForgotPasswordInvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordInvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordNotFoundError,
        InternalServerError: ForgotPasswordInternalServerError,
        BadGatewayError: ForgotPasswordBadGatewayError,
        GatewayTimeoutError: ForgotPasswordGatewayTimeoutError,
        GenericError: ForgotPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSigninConfigurationError: {
        InvalidParameterError: GetSigninConfigurationInvalidParameterError,
        NotFoundError: GetSigninConfigurationNotFoundError,
        InternalServerError: GetSigninConfigurationInternalServerError,
        BadGatewayError: GetSigninConfigurationBadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationGatewayTimeoutError,
        GenericError: GetSigninConfigurationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetPasswordError: {
        InvalidParameterError: ResetPasswordInvalidParameterError,
        InvalidSecretError: ResetPasswordInvalidSecretError,
        ExpiredSecretError: ResetPasswordExpiredSecretError,
        NotFoundError: ResetPasswordNotFoundError,
        InternalServerError: ResetPasswordInternalServerError,
        BadGatewayError: ResetPasswordBadGatewayError,
        GatewayTimeoutError: ResetPasswordGatewayTimeoutError,
        GenericError: ResetPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SsoSigninError: {
        InvalidParameterError: SsoSigninInvalidParameterError,
        NotFoundError: SsoSigninNotFoundError,
        ConflictError: SsoSigninConflictError,
        InternalServerError: SsoSigninInternalServerError,
        BadGatewayError: SsoSigninBadGatewayError,
        GatewayTimeoutError: SsoSigninGatewayTimeoutError,
        GenericError: SsoSigninGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
